import React from 'react';
import ImageGallery from './ImageGallery';
import '../css/carousel-gallery.css';
import '../css/app-carousel-gallery.css';

export default class CodeGallery extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showIndex: false,
      showBullets: false,
      infinite: true,
      showThumbnails: true,
      showFullscreenButton: true,
      showGalleryFullscreenButton: true,
      showPlayButton: false,
      showGalleryPlayButton: false,
      showNav: true,
      isRTL: false,
      slideDuration: 450,
      slideInterval: 2000,
      thumbnailPosition: 'bottom',
      showVideo: {},
    };

    this.images = [
      {
        original: `https://kevinoleary.net/img/jp-morgan-careers-site-01.jpg`,
        thumbnail: `https://kevinoleary.net/img/jp-morgan-careers-site-01.jpg`,
        description: 'careers.jpmorgan.com - HTML, CSS, Javascript, Angular',
      },
      {
        original: `https://kevinoleary.net/img/democracy-dot-com-01.jpg`,
        thumbnail: `https://kevinoleary.net/img/democracy-dot-com-01.jpg`,
        description: 'democracy.com - HTML, CSS, Bootstrap, Javascript',
      },
      {
        original: `https://kevinoleary.net/img/ny-times-site-01.png`,
        thumbnail: `https://kevinoleary.net/img/ny-times-site-01.png`,
        description: 'nytimes.com - HTML, CSS, Javascript, Photoshop',
      },
      {
        original: `https://kevinoleary.net/img/con-ed-energy-efficiency-01.png`,
        thumbnail: `https://kevinoleary.net/img/con-ed-energy-efficiency-01.png`,
        description: 'coned.com - HTML, CSS, Javascript',
      },
      {
        original: `https://kevinoleary.net/img/away-travel-signup-01.png`,
        thumbnail: `https://kevinoleary.net/img/away-travel-signup-01.png`,
        description: 'awaytravel.com - HTML, CSS, Javascript',
      },
      {
        original: `https://kevinoleary.net/img/advocate-insiders-01.png`,
        thumbnail: `https://kevinoleary.net/img/advocate-insiders-01.png`,
        description: 'advocateinsiders.com - HTML, CSS, Wordpress',
      },
      {
        original: `https://kevinoleary.net/img/blue-buffalo-site-01.png`,
        thumbnail: `https://kevinoleary.net/img/blue-buffalo-site-01.png`,
        description: 'bluebuffalo.com - HTML, CSS, Javascript',
      },
      {
        original: `https://kevinoleary.net/img/the-bellport-01.png`,
        thumbnail: `https://kevinoleary.net/img/the-bellport-01.png`,
        description: 'The Bellport - HTML, CSS, Wordpress, Photography',
      },
    ];
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.slideInterval !== prevState.slideInterval ||
      this.state.slideDuration !== prevState.slideDuration
    ) {
      // refresh setInterval
      this._imageGallery.pause();
      this._imageGallery.play();
    }
  }

  _onImageClick(event) {
    console.debug(
      'clicked on image',
      event.target,
      'at index',
      this._imageGallery.getCurrentIndex(),
    );
  }

  _onImageLoad(event) {
    console.debug('loaded image', event.target.src);
  }

  _onSlide(index) {
    this._resetVideo();
    console.debug('slid to index', index);
  }

  _onPause(index) {
    console.debug('paused on index', index);
  }

  _onScreenChange(fullScreenElement) {
    console.debug('isFullScreen?', !!fullScreenElement);
  }

  _onPlay(index) {
    console.debug('playing from index', index);
  }

  _handleInputChange(state, event) {
    this.setState({ [state]: event.target.value });
  }

  _handleCheckboxChange(state, event) {
    this.setState({ [state]: event.target.checked });
  }

  _handleThumbnailPositionChange(event) {
    this.setState({ thumbnailPosition: event.target.value });
  }

  // _getStaticImages() {
  //   let images = [];
  //   for (let i = 2; i < 12; i++) {
  //     images.push({
  //       original: `${PREFIX_URL}${i}.jpg`,
  //       thumbnail: `${PREFIX_URL}${i}t.jpg`,
  //     });
  //   }

  //   return images;
  // }

  _resetVideo() {
    this.setState({ showVideo: {} });

    if (this.state.showPlayButton) {
      this.setState({ showGalleryPlayButton: true });
    }

    if (this.state.showFullscreenButton) {
      this.setState({ showGalleryFullscreenButton: true });
    }
  }

  _toggleShowVideo(url) {
    this.state.showVideo[url] = !Boolean(this.state.showVideo[url]);
    this.setState({
      showVideo: this.state.showVideo,
    });

    if (this.state.showVideo[url]) {
      if (this.state.showPlayButton) {
        this.setState({ showGalleryPlayButton: false });
      }

      if (this.state.showFullscreenButton) {
        this.setState({ showGalleryFullscreenButton: false });
      }
    }
  }

  _renderVideo(item) {
    return (
      <div className="image-gallery-image">
        {this.state.showVideo[item.embedUrl] ? (
          <div className="video-wrapper">
            <a className="close-video" onClick={this._toggleShowVideo.bind(this, item.embedUrl)} />
            <iframe
              width="560"
              height="315"
              src={item.embedUrl}
              frameBorder="0"
              allowFullScreen
              title="code"
            />
          </div>
        ) : (
          <a onClick={this._toggleShowVideo.bind(this, item.embedUrl)}>
            <div className="play-button" />
            <img src={item.original} alt="screenshot" />
            {item.description && (
              <span className="image-gallery-description" style={{ right: '0', left: 'initial' }}>
                {item.description}
              </span>
            )}
          </a>
        )}
      </div>
    );
  }

  render() {
    return (
      <section className="app">
        <ImageGallery
          ref={i => (this._imageGallery = i)}
          items={this.images}
          lazyLoad={true}
          onClick={this._onImageClick.bind(this)}
          onImageLoad={this._onImageLoad}
          onSlide={this._onSlide.bind(this)}
          onPause={this._onPause.bind(this)}
          onScreenChange={this._onScreenChange.bind(this)}
          onPlay={this._onPlay.bind(this)}
          infinite={this.state.infinite}
          showBullets={this.state.showBullets}
          showFullscreenButton={
            this.state.showFullscreenButton && this.state.showGalleryFullscreenButton
          }
          showPlayButton={this.state.showPlayButton && this.state.showGalleryPlayButton}
          showThumbnails={this.state.showThumbnails}
          showIndex={this.state.showIndex}
          showNav={this.state.showNav}
          isRTL={this.state.isRTL}
          thumbnailPosition={this.state.thumbnailPosition}
          slideDuration={parseInt(this.state.slideDuration)}
          slideInterval={parseInt(this.state.slideInterval)}
          additionalClass="app-image-gallery"
        />
      </section>
    );
  }
}
